module.exports = __webpack_public_path__ + "static/media/schmitz-cargobull.4172c957.PDF";